import { CircularProgress, Stack, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { RoleTablePropsType } from "../../../types/container.type";
import DeleteIcon from '@mui/icons-material/Delete';
import { BaseButton } from "../../../components/button/styled";

export const RoleTable: React.FC<RoleTablePropsType> = ({ rows, handleItemClick, selectedRoleId }) => {
    const roleTableHeaders = ["Role Name", "Description", "Action"];
    return (
        <BaseTable
            headers={roleTableHeaders}
        >
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow
                            key={index}
                        >
                            <TableCell>{row?.title}</TableCell>
                            <TableCell>{row?.description}</TableCell>
                            <TableCell>
                                <Stack
                                    direction={"row"}
                                    gap={"calc(var(--flex-gap)/4)"}
                                >
                                    <BaseButton
                                        variant="contained"
                                        bgcolor="var(--primary-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize={"14px"}
                                        onClick={(e) => handleItemClick?.(e, row.id, "edit")}
                                    >
                                        <Typography
                                            variant={"button"}
                                            fontFamily={"inherit"}
                                            fontWeight={"inherit"}
                                            fontSize={"inherit"}
                                            lineHeight={"inherit"}
                                            color={"inherit"}
                                            textTransform={"inherit"}
                                        >
                                            Edit
                                        </Typography>
                                    </BaseButton>
                                    <BaseButton
                                        variant="contained"
                                        bgcolor="var(--text-salmon-pink-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize={"14px"}
                                        onClick={(e) => handleItemClick?.(e, { roleId: row.id, institutionId: row.institution }, "delete")}
                                    >
                                        {(selectedRoleId !== null && selectedRoleId === row.id) ? (
                                            <CircularProgress color="inherit" className="loader" />
                                        ) : (
                                            <DeleteIcon />
                                        )}
                                    </BaseButton>
                                </Stack>
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}